// extracted by mini-css-extract-plugin
export default {"formLabel":"formLabel__24z64","marginNone":"marginNone__si4hs"};